module.exports = __webpack_public_path__ + "static/img/icon-training4.e955cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-training4.png
// module id = kIto
// module chunks = 21